export default import.meta.ROLLDOWN_FILE_URL_4tdpHUgxsjM2BVMh2n1Y5Q